// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._1r04idpf{inset:0}._18m91wug{overflow-y:auto}\n._1pbybfng{z-index:500}\n._bfhk1j28{background-color:transparent}\n._bfhk705f{background-color:var(--_10avjlk)}\n._kqsw1n9t{position:fixed}\n._lcxv1wug{pointer-events:auto}\n._lcxvglyw{pointer-events:none}", ""]);
// Exports
module.exports = exports;
